(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    // Monovits: the contact form is a native POST — the page unloads and comes back. Between
  // the click and the unload the button stayed live and unlabelled, so a slow connection
  // invited a second submit. Mark it busy and disable it for that window.
  //
  // Delegated on document rather than bound per-form: Shopify concatenates every block's
  // component JS into one bundle that runs once, before and independently of any particular
  // block being in the DOM. Wrapped in an IIFE so nothing lands in global scope (a top-level
  // `const` here would collide across the shared bundle).
  (() => {
    const busyForm = (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.classList.contains('contact-form__form')) return;

      const button = form.querySelector('button[type="submit"]');
      if (!button) return;

      button.setAttribute('aria-busy', 'true');
      // Deferred: disabling synchronously inside the submit handler is safe for form data,
      // but a task-boundary hop keeps it clear of any UA that reads the button after the
      // event. The submit button carries no name/value, so nothing is lost either way.
      setTimeout(() => {
        button.disabled = true;
      }, 0);
    };

    const clearBusy = () => {
      document.querySelectorAll('.contact-form__form button[type="submit"]').forEach((button) => {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      });
    };

    document.addEventListener('submit', busyForm);
    // Back/forward cache restores the DOM as it was at unload — with the button still
    // disabled. Reset on restore so a returning visitor can submit again.
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) clearBusy();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mv-free-shipping-nudge"] && !Shopify.designMode) return;
  try {
    class MvFreeShippingNudge extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-mv-nudge-text]');
      if (!this.output) return;

      this.threshold = parseInt(this.dataset.threshold, 10);
      if (!Number.isFinite(this.threshold) || this.threshold < 2) return;

      this.textBelow = this.dataset.textBelow || '';
      this.textMet = this.dataset.textMet || '';
      if (!this.textBelow && !this.textMet) return;

      this.input = this.findQuantityInput();
      // No quantity control on the page: the server-rendered default line is
      // already correct, so leave it alone.
      if (!this.input) return;

      this.sync = this.sync.bind(this);
      this.input.addEventListener('input', this.sync);
      this.input.addEventListener('change', this.sync);

      // Stepper buttons often set `value` without dispatching an event the
      // input itself hears. Read after the theme's own handler has run.
      this.wrapper = this.input.closest('.quantity-selector, quantity-selector, .quantity, form') || document;
      this.deferredSync = () => setTimeout(this.sync, 0);
      this.wrapper.addEventListener('click', this.deferredSync);

      this.sync();
    }

    disconnectedCallback() {
      if (!this.input) return;
      this.input.removeEventListener('input', this.sync);
      this.input.removeEventListener('change', this.sync);
      if (this.wrapper) this.wrapper.removeEventListener('click', this.deferredSync);
    }

    findQuantityInput() {
      return (
        document.querySelector('form[action*="/cart/add"] input[name="quantity"]') ||
        document.querySelector('input[name="quantity"]')
      );
    }

    sync() {
      const quantity = parseInt(this.input.value, 10);
      if (!Number.isFinite(quantity)) return;

      const met = quantity >= this.threshold;
      const next = met ? this.textMet : this.textBelow;
      if (!next || next === this.output.textContent.trim()) return;

      const apply = () => {
        this.output.textContent = next;
        this.output.dataset.state = met ? 'met' : 'below';
        this.output.dataset.swapping = 'false';
      };

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        apply();
        return;
      }

      this.output.dataset.swapping = 'true';
      setTimeout(apply, 180);
    }
  }

  if (!customElements.get('mv-free-shipping-nudge')) {
    customElements.define('mv-free-shipping-nudge', MvFreeShippingNudge);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mv-product-description"] && !Shopify.designMode) return;
  try {
    /**
   * Description clamp — progressive enhancement only.
   *
   * Without this script nothing happens: `data-mv-clamp` is never written, the
   * CSS clamp never matches, the toggle keeps its server-rendered `hidden`, and
   * the description renders in full exactly as it did before. The enhancement
   * fails open by construction, not by a fallback path.
   *
   * What it adds, at EVERY width: a five-line clamp on a description that would
   * otherwise overflow it, plus a "+ MORE" / "− LESS" control.
   *
   * It was gated to 990px up until 2026-09-02, because the original point was
   * not tidiness — it was that the buy column has to fit inside the viewport
   * for `position: sticky` in `mv-product-main` to pin it from scroll position
   * zero instead of letting it travel first. That still holds at desktop
   * widths. The owner then asked for the same truncation on phones, where the
   * reason is different: below 990px the layout is one column, so an unbounded
   * merchant-authored description pushes the accordions and everything under
   * them off the first screen. Same mechanism, two reasons, no breakpoint.
   *
   * The height it publishes is picked up for free: that section already runs a
   * ResizeObserver on the column and republishes `--mv-buy-h` whenever the
   * column's box changes, and collapsing or expanding this block changes it.
   * Nothing here needs to know about that variable, and nothing here writes it.
   *
   * Wrapped in an IIFE. Shopify concatenates every section and block javascript
   * block into one bundle sharing a single global scope, so a top-level
   * declaration here is a global for the whole site and a name collision is a
   * SyntaxError that takes the entire bundle down.
   */
  (function () {
    /* The clamp height, in lines. Duplicated in the stylesheet above rather
       than threaded through a custom property, because `-webkit-line-clamp`
       takes an integer and the two places that need it are a CSS declaration
       and a JS multiplication — one constant, stated in each language, with the
       other named in both comments. Not a schema setting: see the stylesheet. */
    const CLAMP_LINES = 5;

    /**
     * Is the description taller than the clamp would allow?
     *
     * Measured with the clamp OFF. `scrollHeight` on a clamped `-webkit-box` is
     * not reliably the unclamped content height across engines, and the
     * question being asked is precisely "what would this be if it were not
     * clamped" — so the attribute comes off for the measurement and goes back
     * exactly as it was. Both writes are synchronous and inside one frame, so
     * nothing is ever painted in the intermediate state.
     *
     * The comparison is against line-height rather than against any stored
     * pixel figure, so it follows the merchant's own size setting and the
     * fluid type scale without either being restated here. The 1px margin
     * absorbs sub-pixel line boxes; without it a description that lands on
     * exactly five lines offers a control that reveals nothing.
     */
    function overflowsClamp(block, desc) {
      const previous = block.getAttribute('data-mv-clamp');
      if (previous !== null) block.removeAttribute('data-mv-clamp');
      const lineHeight = parseFloat(getComputedStyle(desc).lineHeight);
      const full = desc.scrollHeight;
      if (previous !== null) block.setAttribute('data-mv-clamp', previous);
      if (!lineHeight) return false;
      return full > lineHeight * CLAMP_LINES + 1;
    }

    /**
     * One writer for the whole state, so the attribute, the control's
     * visibility, its label and its `aria-expanded` can never disagree.
     *
     * `state` is 'collapsed', 'expanded', or null for "no clamp is being
     * offered here" — which since 2026-09-02 means only one thing: a
     * description short enough to fit inside the clamp. In the null case
     * `aria-expanded` is set to true rather than left stale: the full text IS
     * showing, and the control is out of the accessibility tree anyway once it
     * is hidden.
     */
    function setState(block, toggle, state) {
      if (state === null) {
        block.removeAttribute('data-mv-clamp');
        toggle.hidden = true;
        toggle.setAttribute('aria-expanded', 'true');
        return;
      }
      const collapsed = state === 'collapsed';
      block.setAttribute('data-mv-clamp', state);
      toggle.hidden = false;
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      const label = collapsed ? toggle.dataset.labelMore : toggle.dataset.labelLess;
      if (label) toggle.textContent = label;
    }

    function init(block) {
      const desc = block.querySelector('.mv-desc');
      const toggle = block.querySelector('[data-mv-desc-toggle]');
      if (!desc || !toggle) return;

      /* Intent, held across resizes. Someone who opened the description and
         then resized the window — or rotated a phone, which rewraps the copy
         and can change whether it overflows at all — must not find it closed
         again underneath them. */
      let expanded = false;

      function apply() {
        /* No breakpoint test any more — the clamp applies wherever the copy
           actually overflows it. `overflowsClamp` is still the whole gate, and
           it is measured against the live line-height, so a narrower column
           that wraps the same copy onto more lines is answered correctly
           without a second constant. */
        if (!overflowsClamp(block, desc)) {
          setState(block, toggle, null);
          return;
        }
        setState(block, toggle, expanded ? 'expanded' : 'collapsed');
      }

      toggle.addEventListener('click', () => {
        expanded = !expanded;
        setState(block, toggle, expanded ? 'expanded' : 'collapsed');
      });

      /* A keyboard user can tab to a link inside the clipped tail; the browser
         then scroll-into-views the hidden overflow box, leaving the clamp
         stranded mid-copy with no visible way back. Focus entering the
         description is the same intent as the toggle, arrived at by keyboard —
         expand. Latent today (no live description carries a link), but merchant
         richtext can add one at any time. */
      desc.addEventListener('focusin', () => {
        if (!expanded) {
          expanded = true;
          setState(block, toggle, 'expanded');
        }
      });

      /* Collapsed into one frame: `resize` fires continuously and `apply`
         forces layout twice. Same shape as the gallery's own resize handling in
         `mv-product-main`. */
      let queued = false;
      function sync() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          apply();
        });
      }

      apply();
      addEventListener('resize', sync);

      /* A late webfont rewraps the copy, which can move it across the five-line
         line either way. Without this the decision would be right only for the
         fallback face's metrics. */
      if (document.fonts && typeof document.fonts.ready === 'object') {
        document.fonts.ready.then(sync).catch(() => {});
      }
    }

    function initAll() {
      for (const block of document.querySelectorAll('.mv-desc-block')) init(block);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
